import React from 'react'
import { colors } from '../../styles/tokens'
import { formatDate } from '../../utils/formatters'

/**
 * Componentes de detalhe para cada tipo de bloco
 * 
 * Single Responsibility: Renderização de detalhes específicos por tipo
 */

export function FlightDetails({ block }) {
  const details = block.details || {}
  const segments = details.segments || []

  return (
    <div style={{ fontSize: '0.8rem', color: colors.text.secondary, marginTop: '0.25rem' }}>
      {segments.map((seg, i) => (
        <div key={i} style={{ marginBottom: '0.25rem' }}>
          <span style={{ fontWeight: 500, color: colors.text.primary }}>
            {seg.origin} → {seg.destination}
          </span>
          {' | '}
          {seg.departure_date && `${formatDate(seg.departure_date)} `}
          {seg.departure_time && `${seg.departure_time}`}
          {seg.arrival_time && ` → ${seg.arrival_time}`}
          {seg.duration && ` | ${seg.duration}`}
        </div>
      ))}
      {details.is_direct === false && <span>🔄 Com escala</span>}
      {details.is_direct === true && <span>✅ Direto</span>}
      {details.baggage_text && (
        <span> | 🧳 {details.baggage_text}</span>
      )}
    </div>
  )
}

export function HotelDetails({ block }) {
  const details = block.details || {}

  return (
    <div style={{ fontSize: '0.8rem', color: colors.text.secondary, marginTop: '0.25rem' }}>
      {details.stars && <span>{'⭐'.repeat(details.stars)} </span>}
      {details.address && <div>{details.address}</div>}
      <div>
        {details.checkin_date && `${formatDate(details.checkin_date)}`}
        {details.checkout_date && ` → ${formatDate(details.checkout_date)}`}
        {details.nights && ` | ${details.nights} noites`}
      </div>
      {details.room_type && <div>🛏️ {details.room_type}</div>}
      {details.meal_plan && <div>🍽️ {details.meal_plan}</div>}
    </div>
  )
}

export function TransferDetails({ block }) {
  const details = block.details || {}

  return (
    <div style={{ fontSize: '0.8rem', color: colors.text.secondary, marginTop: '0.25rem' }}>
      {details.origin_name && details.destination_name && (
        <div>{details.origin_name} → {details.destination_name}</div>
      )}
      <div>
        {details.vehicle_type && `🚗 ${details.vehicle_type}`}
        {details.is_private && ' | Privado'}
        {details.pickup_date && ` | ${formatDate(details.pickup_date)}`}
        {details.pickup_time && ` ${details.pickup_time}`}
      </div>
    </div>
  )
}

export function TourDetails({ block }) {
  const details = block.details || {}

  return (
    <div style={{ fontSize: '0.8rem', color: colors.text.secondary, marginTop: '0.25rem' }}>
      {details.time && <span>🕐 {details.time}</span>}
      {details.duration && <span> | ⏱️ {details.duration}</span>}
      {details.includes && details.includes.length > 0 && (
        <div style={{ marginTop: '0.25rem' }}>
          ✅ {details.includes.slice(0, 2).join(', ')}
          {details.includes.length > 2 && '...'}
        </div>
      )}
    </div>
  )
}

export function CarDetails({ block }) {
  const details = block.details || {}

  return (
    <div style={{ fontSize: '0.8rem', color: colors.text.secondary, marginTop: '0.25rem' }}>
      {details.company && <span>{details.company} | </span>}
      {details.category && <span>{details.category}</span>}
      {details.model && <span> - {details.model}</span>}
      <div>
        {details.pickup_date && `Retirada: ${formatDate(details.pickup_date)}`}
        {details.pickup_time && ` ${details.pickup_time}`}
        {details.pickup_location && ` em ${details.pickup_location}`}
      </div>
      <div>
        {details.dropoff_date && `Devolução: ${formatDate(details.dropoff_date)}`}
        {details.dropoff_time && ` ${details.dropoff_time}`}
        {details.dropoff_location && ` em ${details.dropoff_location}`}
      </div>
    </div>
  )
}

/**
 * Renderiza detalhes do bloco baseado no tipo
 */
export default function BlockDetails({ block }) {
  switch (block.type) {
    case 'flight': return <FlightDetails block={block} />
    case 'hotel': return <HotelDetails block={block} />
    case 'transfer': return <TransferDetails block={block} />
    case 'tour': return <TourDetails block={block} />
    case 'car': return <CarDetails block={block} />
    default: return null
  }
}
